import {
  showCustomToast,
  updateCustomToast,
} from 'common/components/CustomToast/utils';
import React from 'react';
import { BlockBlobClient } from '@azure/storage-blob';
import { GetPaymentDetails_payment } from 'ap/paymentTracking/view/PaymentTrackingView/__generated__/GetPaymentDetails';
import {
  PaymentUploadDocument,
  PaymentUploadDocumentVariables,
  PaymentUploadDocument_paymentUploadDocument,
} from './__generated__/PaymentUploadDocument';
import { useMutation } from '@apollo/client';

import { PaymentAvailableDocumentTypes } from 'ap/paymentTracking/view/PaymentTrackingView/__generated__/PaymentAvailableDocumentTypes';
import { UploadFiles } from 'common/components/UploadFiles';
import { DocumentTypeOption } from 'common/components/UploadFiles/view';
import { useFormikContext } from 'formik';

import INVOICE_UPLOAD_DOCUMENT from './PaymentUploadDocument.graphql';
interface UploadFormProps {
  availableDocumentTypes: PaymentAvailableDocumentTypes | undefined;
  payment?: GetPaymentDetails_payment;
  onUpload?: (
    fileSelected: File,
    documentData: PaymentUploadDocument_paymentUploadDocument,
    toastId: string
  ) => void;
}
export const UploadForm: React.FC<UploadFormProps> = ({
  availableDocumentTypes,
  payment,
  onUpload,
}) => {
  const { dirty } = useFormikContext();
  const [uploadDocument] = useMutation<
    PaymentUploadDocument,
    PaymentUploadDocumentVariables
  >(INVOICE_UPLOAD_DOCUMENT, { errorPolicy: 'all' });

  const { isDraft } = { ...payment?.payCycle };
  const documentTypeOptions =
    availableDocumentTypes?.paymentAvailableDocumentTypes?.nodes.map(
      (doctype) =>
        ({
          key: doctype.id,
          text: doctype.documentType || '',
          isAccountingDocument: doctype.isAccountingDocument,
          extractionTypes: doctype.extractionTypes,
          title:
            isDraft && doctype.isAccountingDocument
              ? 'Upload prohibited during/after the approval process'
              : undefined,
          disabled: (!isDraft && doctype.isAccountingDocument) || undefined,
        } as DocumentTypeOption)
    ) || [];

  return (
    <UploadFiles
      documentTypes={documentTypeOptions!}
      uploadDocument={{
        uploadDocumentData: async (documentType, data, filSelected) => {
          filSelected.map(async (fileEntity, fileIndex) => {
            // const toastId = `file.name.${fileEntity?.name}.${fileIndex}`;
            const toastId = showCustomToast({
              content: `Uploading ${fileEntity?.name}...`,
              appearance: 'info',
              autoDismiss: false,
            });

            const uploadMutationResults = await uploadDocument({
              variables: {
                document: {
                  ...data,

                  documentTypeId: parseInt(documentType.key.toString()),
                  filename: fileEntity.name,
                },
                paymentId: payment?.id!,
              },
            });

            if (uploadMutationResults.errors) {
              updateCustomToast(toastId!, {
                content: `Upload of ${fileEntity.name} failed`,
                appearance: 'error',
                autoDismiss: true,
              });
            }

            if (
              uploadMutationResults.data?.paymentUploadDocument?.document &&
              uploadMutationResults.data?.paymentUploadDocument?.document
                ._documentFileId
            ) {
              onUpload?.(
                fileEntity,
                uploadMutationResults.data?.paymentUploadDocument,
                toastId!
              );

              const client = new BlockBlobClient(
                uploadMutationResults.data?.paymentUploadDocument?.uploadLink
              );
              await client.uploadData(fileEntity);
            }
          });
        },
      }}
      disableUpload={dirty}
    />
  );
};
